import React from 'react';
import {
  Redirect, Route, Switch,
} from 'react-router-dom';

import PibPage from '../PibPage/PibPage';
import SiteSeePage from '../SiteSeePage/SiteSeePage';
import MapTilesPage from '../MapTilesPage/MapTilesPage';
import MapOnlyPage from '../MapOnlyPage/MapOnlyPage';
import TestPage from '../TestPage/TestPage';
import FloorPlanPrintPage from '../FloorPlanPrintPage/FloorPlanPrintPage';

const NoChromeComponents = () => (

  <Switch>

    {/* These components behave as pages */}
    <Route
      path="/:communitySlug/:sanitizedTitle/:drupalNid"
      exact
      component={PibPage}
    />

    <Route
      path="/:communitySlug/:drupalBundleType/:sanitizedTitle/:drupalNid"
      exact
      component={FloorPlanPrintPage}
    />

    {/* These components are full screen */}
    <Route
      path="/map-tiles"
      exact
      component={MapTilesPage}
    />

    <Route
      path="/test"
      exact
      component={TestPage}
    />

    <Route
      path="/map-only"
      exact
      component={MapOnlyPage}
    />

    <Route
      path="/tourguide"
      exact
      component={SiteSeePage}
    />

    <Redirect from="/map-embed" to="/tourguide" />

  </Switch>
);

export default NoChromeComponents;
